import React, { useEffect, useState } from 'react';
import { HeroSection } from '../components/HeroSection';
import { AssetOverview } from '../components/AssetOverview';
import { TenancySchedule } from '../components/TenancySchedule';
import { TenantProfile } from '../components/TenantProfile';
import { ContactFooter } from '../components/ContactFooter';
import { ArrowRight } from 'lucide-react';
export function PropertyLanding() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-white text-[#1A1A1A] font-sans" data-id="element-144">
      {/* Sticky Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md py-3' : 'bg-transparent py-6'}`} data-id="element-145">
        <div className="max-w-7xl mx-auto px-6 flex justify-between items-center" data-id="element-146">
          <div className={`transition-opacity duration-300 ${scrolled ? 'opacity-100' : 'opacity-0'}`} data-id="element-147">
            <p className="font-bold text-[#1A1A1A] uppercase tracking-wider text-sm md:text-base" data-id="element-148">
              401 Chapel St, South Yarra
            </p>
          </div>

          <button className="bg-[#1A1A1A] text-white px-6 py-2 rounded-full text-sm font-bold uppercase tracking-wider hover:bg-gray-800 transition-colors flex items-center gap-2" data-id="element-149">
            Enquire Now <ArrowRight className="w-4 h-4" data-id="element-150" />
          </button>
        </div>
      </nav>

      <main data-id="element-151">
        <HeroSection data-id="element-152" />
        <AssetOverview data-id="element-153" />
        <TenancySchedule data-id="element-154" />
        <TenantProfile data-id="element-155" />
      </main>

      <ContactFooter data-id="element-156" />
    </div>;
}